 // /home/clement/compta-app/client/src/components/Facturation/Devis/CreerDevis.js
 
import React, { useState } from 'react';
import { TextField, Button, Box, MenuItem, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { createDevis } from '../../../api/devisApi'; // Assure-toi que ce fichier existe

const CreerDevis = () => {
  const navigate = useNavigate();

  // État initial du formulaire
  const [formData, setFormData] = useState({
    clientId: '',
    date: new Date().toISOString().split('T')[0], // Date du jour par défaut
    lignes: [{ description: '', quantite: 1, prixUnitaire: 0 }],
    statut: 'brouillon',
  });

  // Exemple de liste de clients (à remplacer par un appel API)
  const [clients] = useState([
    { id: 1, nom: 'Client A' },
    { id: 2, nom: 'Client B' },
  ]);

  // Gestion des changements dans les champs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Gestion des changements dans les lignes de devis
  const handleLigneChange = (index, e) => {
    const { name, value } = e.target;
    const nouvellesLignes = [...formData.lignes];
    nouvellesLignes[index][name] = value;
    setFormData({ ...formData, lignes: nouvellesLignes });
  };

  // Ajouter une nouvelle ligne de devis
  const ajouterLigne = () => {
    setFormData({
      ...formData,
      lignes: [...formData.lignes, { description: '', quantite: 1, prixUnitaire: 0 }],
    });
  };

  // Supprimer une ligne de devis
  const supprimerLigne = (index) => {
    const nouvellesLignes = [...formData.lignes];
    nouvellesLignes.splice(index, 1);
    setFormData({ ...formData, lignes: nouvellesLignes });
  };

  // Soumission du formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createDevis(formData);
      alert('Devis créé avec succès !');
      navigate('/devis'); // Redirige vers la liste des devis
    } catch (error) {
      console.error("Erreur lors de la création du devis :", error);
      alert('Erreur lors de la création du devis.');
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
      <Typography variant="h5" gutterBottom>
        Créer un nouveau devis
      </Typography>

      <TextField
        select
        label="Client"
        name="clientId"
        value={formData.clientId}
        onChange={handleChange}
        fullWidth
        margin="normal"
        required
      >
        {clients.map((client) => (
          <MenuItem key={client.id} value={client.id}>
            {client.nom}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        label="Date"
        type="date"
        name="date"
        value={formData.date}
        onChange={handleChange}
        fullWidth
        margin="normal"
        InputLabelProps={{ shrink: true }}
        required
      />

      <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
        Lignes du devis
      </Typography>

      {formData.lignes.map((ligne, index) => (
        <Box key={index} sx={{ display: 'flex', gap: 2, mb: 2 }}>
          <TextField
            label="Description"
            name="description"
            value={ligne.description}
            onChange={(e) => handleLigneChange(index, e)}
            fullWidth
            required
          />
          <TextField
            label="Quantité"
            name="quantite"
            type="number"
            value={ligne.quantite}
            onChange={(e) => handleLigneChange(index, e)}
            fullWidth
            required
          />
          <TextField
            label="Prix unitaire (€)"
            name="prixUnitaire"
            type="number"
            value={ligne.prixUnitaire}
            onChange={(e) => handleLigneChange(index, e)}
            fullWidth
            required
          />
          <Button
            variant="outlined"
            color="error"
            onClick={() => supprimerLigne(index)}
            sx={{ alignSelf: 'center' }}
          >
            Supprimer
          </Button>
        </Box>
      ))}

      <Button
        variant="contained"
        color="secondary"
        onClick={ajouterLigne}
        sx={{ mb: 2 }}
      >
        Ajouter une ligne
      </Button>

      <Button type="submit" variant="contained" color="primary">
        Enregistrer le devis
      </Button>
    </Box>
  );
};

export default CreerDevis;

